export default "__VITE_ASSET__Dk7_Kkam__"